<template>
  <div>
    <DisplayChangeByPrevPageTypeAddMembershipAppeal :prev-page-type="prevPageType" />
    <section class="outerOfMemberContent">
      <p v-if="prevPageType.isOc()" class="announceForAlreadyMember">すでに会員登録済みの方はこちら</p>
      <PageTop class="pageTopComponent" />
      <p class="loginAnnounce">ログインにはスタディサプリ共通のIDを利用できます。</p>
      <p class="loginAnnounceGroup">※在籍校で利用している団体利用アカウントの場合はログインできません</p>
      <ServiceLogoList class="logos" />
      <InputWithLabel
        v-model="handleUserName"
        area-label="ユーザー名またはメールアドレス"
        input-type="text"
        placeholder="ユーザー名、メールアドレスを入力"
        maxlength="161"
        :validation-list="[VALIDATION_LIST.EMPTY, VALIDATION_LIST.USER_NAME_AND_EMAIL]"
        @watchValidation="watchUserNameValidation"
      />
      <Password
        v-model="handlePassword"
        area-label="パスワード"
        placeholder="パスワードを入力"
        right-space
        maxlength="72"
        class="inputArea"
        @watchValidation="watchPasswordValidation"
      />
      <ErrorMessage :error-message-list="serverErrorList" :result-code="resultCode" class="errorMessageComponent" />
      <CheckboxArea v-model="staySignInFlag" class="checkboxComponent" />
      <TermsAndPolicy class="termsAndPolicyComponent" />
      <ButtonTypeCustom
        button-type="button"
        button-text="上記に同意してログインする"
        button-color="colorPrimary"
        button-size="sizeLarge"
        :class="{ 'is-disabled': !canSendRequest }"
        class="loginButton"
        max-width-none
        @button-clicked="login"
      />
      <ResolutionLostInfo
        lost-user-id-url="/rnet/info/61.html"
        lost-user-id-text="ユーザー名がわからない場合"
        lost-password-url="/rnet/info/60.html"
        lost-password-text="パスワードがわからない場合"
      />
    </section>
  </div>
</template>

<script>
import axios from 'axios';
import qs from 'qs';
import DisplayChangeByPrevPageTypeAddMembershipAppeal from '../common/DisplayChangeByPrevPageType_addMembershipAppeal.vue';
import PageTop from './PageTop';
import ServiceLogoList from '../../../common/sp/ServiceLogo/ServiceLogoList.vue';
import InputWithLabel, { VALIDATION_LIST } from '../../../common/common/Input/InputWithLabel.vue';
import Password from '../../../common/common/Input/Password.vue';
import ErrorMessage from '../../../common/sp/ErrorMessage.vue';
import CheckboxArea from '../common/CheckboxArea.vue';
import TermsAndPolicy from '../../../common/common/Text/TermsAndPolicy.vue';
import ButtonTypeCustom from '../../../common/common/Button/ButtonTypeCustom.vue';
import ResolutionLostInfo from '../common/Text/ResolutionLostInfo.vue';
import { PrevPageType } from '../../../../helper/_prevPageType';
import { judgeErrorAndSendToErrorPage } from '../../../../helper/_responseError';
import { sendLog } from '../../../../helper/_sendLog';

export default {
  components: {
    DisplayChangeByPrevPageTypeAddMembershipAppeal,
    PageTop,
    ServiceLogoList,
    InputWithLabel,
    Password,
    ErrorMessage,
    CheckboxArea,
    TermsAndPolicy,
    ButtonTypeCustom,
    ResolutionLostInfo,
  },
  data() {
    return {
      staySignInFlag: false,
      mailaddressError: '',
      passwordError: '',
      serverErrorList: [],
      resultCode: 0,
      urlAfterSignIn: '',
      input: {
        userName: '',
        password: '',
      },
      hasInnerError: {
        userName: false,
        password: false,
      },
      postProcessingFlg: false, // ダブルサブミット対策用フラグ
      sendScrollLog: false, // 会員登録ボタンが表示された時に発火するログが飛んだか判定するフラグ
      scrollLogTargetList: [],
      prevPageType: {},
    };
  },
  computed: {
    VALIDATION_LIST() {
      return VALIDATION_LIST;
    },
    /**
     * @description ボタン活性／非活性を制御するフラグ。入力済みか、エラーがない場合にログイン可能
     */
    canSendRequest() {
      const hasValue = this.input.userName && this.input.password;
      const hasError = this.hasInnerError.userName || this.hasInnerError.password;
      if (!hasError && hasValue) return true;

      return false;
    },
    handleUserName: {
      get() {
        return this.input.userName;
      },
      set(value) {
        this.input.userName = value;
      },
    },
    handlePassword: {
      get() {
        return this.input.password;
      },
      set(value) {
        this.input.password = value;
      },
    },
  },
  created() {
    this.prevPageType = new PrevPageType(frontend.previousPageType);
    this.urlAfterSignIn = this.prevPageType.getUrlAfterCheckPrevPage(
      this.$isSp,
      frontend.nextPageUrlParams,
      frontend.referrer,
    );
    if (this.urlAfterSignIn === '/smp/') {
      this.urlAfterSignIn = `${this.urlAfterSignIn}?login=1`;
    }
  },
  methods: {
    watchUserNameValidation(value) {
      this.hasInnerError.userName = value;
    },
    watchPasswordValidation(value) {
      this.hasInnerError.password = value;
    },
    login() {
      // ダブルサブミット対策
      if (this.postProcessingFlg) return;
      this.postProcessingFlg = true;

      axios
        .post(
          '/smp2/quipMember/auth/signInJson/',
          qs.stringify({
            userId: this.input.userName,
            password: this.input.password,
            staySignInFlag: this.staySignInFlag,
            'org.apache.struts.taglib.html.TOKEN': frontend.csrfToken,
          }),
        )
        .then((response) => {
          if (!response) throw error;
          if (!response.data) throw error;
          if (response.data.resultCode === 0) {
            // 正常系。ログイン導線に応じて画面遷移
            window.location.href = this.urlAfterSignIn;
          } else if (response.data.resultCode === 1) {
            // 汎用エラー
            this.resultCode = response.data.resultCode;
            this.serverErrorList = response.data.errorMessageList;
          } else if (response.data.resultCode === 2) {
            // quipper閉塞エラー
            window.location.href = '/smp2/error/shinroAccountApiMainte/';
          } else if (response.data.resultCode === 3) {
            // toBエラー
            sendLog(window.s, document, `${window.trace_p}_toberror`);
            this.resultCode = response.data.resultCode;
            this.serverErrorList = response.data.errorMessageList;
          } else {
            // 異常なresultCode
            throw error;
          }
        })
        .catch((error) => {
          judgeErrorAndSendToErrorPage(error, this.isSp);
        })
        .finally(() => {
          this.postProcessingFlg = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
@import 'css/contents/common/global';

.outerOfMemberContent {
  padding: 0 20px 22px;
}

.announceForAlreadyMember {
  color: $color-text-secondry;
  font-size: $text-size-paragraph2;
  font-weight: $text-weight-bold;
  line-height: $text-line-height-default;
  margin: 42px 0 16px;
}

.pageTopComponent {
  margin-bottom: 16px;
}

.loginAnnounce {
  color: $color-text-primary;
  font-size: $text-size-paragraph2;
  line-height: $text-line-height-default;
  margin-bottom: 8px;
}

.loginAnnounceGroup {
  color: $color-text-secondry;
  font-size: $text-size-caption1;
  line-height: $text-line-height-default;
  margin-bottom: 8px;
}

.logos {
  margin-bottom: 30px;

  &::v-deep {
    .logoListItemHighSchool,
    .logoListItemUniversity {
      height: 4vw;
      max-height: 15px;
    }
  }
}

.inputArea {
  margin-top: 20px;
}

.errorMessageComponent {
  margin-top: 20px;
}

.checkboxComponent {
  margin-top: 20px;
  margin-bottom: 24px;
}

.termsAndPolicyComponent {
  margin-bottom: 12px;
}

.loginButton {
  margin-bottom: 16px;

  &.is-disabled {
    background-color: $color-background-primary-third-dark;
    pointer-events: none;
  }
}
</style>
